export const propInfo = {
  name: {
    saveSuccess: "Nombre de la propiedad guardado con éxito",
    successTitle: "Éxito",
    saveError: "Error al guardar el nombre de la propiedad",
  },
  capacity: {
    saveSuccess: "Capacidad guardada con éxito",
    saveError: "Error al guardar la capacidad",
  },
  location: {
    loadError: "Error al cargar los datos del anuncio.",
    appliedBulk: "Ubicación aplicada a {count} alojamientos vinculados",
    saveSuccess: "Ubicación guardada con éxito",
    partialError: "Algunos alojamientos no se pudieron actualizar",
    savePropertySuccess: "Ubicación de la propiedad guardada con éxito",
    saveError: "Error al guardar la ubicación de la propiedad",
    loading: "Cargando ubicación del anuncio…",
    noUnitsTitle: "Este anuncio aún no tiene unidades configuradas.",
    noUnitsText: "Crea al menos una unidad para poder configurar la ubicación.",
    bulkNotice: "Este cambio se aplicará a los {count} alojamientos vinculados a {name}.",
  },
  description: {
    saveSuccess: "Descripción guardada con éxito",
    saveError: "Error al guardar la descripción",
    cloneTitleNoun: "descripción",
    cloneItemNoun: "la descripción",
  },
};
